import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import { AppContextProvider } from './context/AppContext';
import React, { useContext, Suspense } from 'react';
import SignIn from "./pages/SignIn";
import PrivateRoute from './components/PrivateRoute'
import ScrollToTop from './components/ScrollToTop';
import Loader from './components/Loader';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import IndexHome from './pages/IndexHome';
import Error from './pages/Error';
import User from './pages/User';
import Hotel from './pages/Hotel';
import Goverment from './pages/Goverment';
import Driver from './pages/Driver';
import Coupon from './pages/Coupon';
import Transaction from './pages/Transaction';
import Banner from './pages/Banner';
import EmailTemplate from './pages/EmailTemplates';
import Content from './pages/Content';
import Notification from './pages/Notification';
import ViewContent from './pages/ViewContent';
import ViewCoupon from './pages/ViewCoupon';
import ViewNotification from './pages/ViewNotification';
import ViewEmailTemplate from './pages/ViewEmailTemplate';
import CarType from './pages/CarType';
import CarMake from './pages/CarMake';
import CarModel from './pages/CarModel';
import PriceMatrix from './pages/PriceMatrix';
import Profile from './pages/Profile';
import LoyalityPointManager from './pages/LoyalityPointManager';
import Voucher from './pages/Voucher';
import OrderManager from './pages/OrderManager';
import ViewRide from './pages/ViewRide';
import ContentPage from './pages/ContentPage';
import SubAdmin from './pages/SubAdmin';
import UserCar from './pages/UserCar';
import ViewTaxiDetails from './pages/ViewTaxiDetails'
window.Buffer = window.Buffer || require("buffer").Buffer;
function App() {

  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={false} />
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/taxi-admin/login" element={<SignIn />} />
      <Route exact path="/taxi-admin/privacy-policy" element={<ContentPage />} />
      <Route path="/" element={<SignIn />} />
      <Route
        path="/taxi-admin/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route exact path="/taxi-admin/" element={<IndexHome />} />
        <Route exact path="/taxi-admin/dashboard" element={<IndexHome />} />
        <Route exact path="/taxi-admin/user-manager" element={<User />} />
        <Route exact path="/taxi-admin/hotel-manager" element={<Hotel />} />
        <Route exact path="/taxi-admin/goverment-manager" element={<Goverment />} />
        <Route exact path="/taxi-admin/driver-manager" element={<Driver />} />
        <Route exact path="/taxi-admin/discount-manager" element={<Coupon />} />
        <Route exact path="/taxi-admin/transaction-manager" element={<Transaction />} />
        <Route exact path="/taxi-admin/notification-manager" element={<Notification />} />
        <Route exact path="/taxi-admin/content-manager" element={<Content />} />
        <Route exact path="/taxi-admin/email-template-manager" element={<EmailTemplate />} />
        <Route exact path="/taxi-admin/banner-manager" element={<Banner />} />

        <Route exact path="/taxi-admin/car-type-manager" element={<CarType />} />
        <Route exact path="/taxi-admin/car-make-manager" element={<CarMake />} />
        <Route exact path="/taxi-admin/car-model-manager" element={<CarModel />} />
        <Route exact path="/taxi-admin/price-matrix-manager" element={<PriceMatrix />} />
        <Route exact path="/taxi-admin/profile" element={<Profile />} />
        <Route exact path="/taxi-admin/loyalty-point-manager" element={<LoyalityPointManager />} />
        <Route exact path="/taxi-admin/voucher-manager" element={<Voucher />} />
        <Route exact path="/taxi-admin/order-manager" element={<OrderManager />} />
        <Route exact path="/taxi-admin/view-ride/:id" element={<ViewRide />} />

        <Route exact path="/taxi-admin/view-coupon/:id" element={<ViewCoupon />} />
        <Route exact path="/taxi-admin/view-driver-details/:id" element={<ViewTaxiDetails />} />
        <Route
          exact
          path="/taxi-admin/view-content/:id"
          element={<ViewContent />}
        />
        <Route
          exact
          path="/taxi-admin/view-notification/:id"
          element={<ViewNotification />}
        />
        <Route
          exact
          path="/taxi-admin/view-email-template/:id"
          element={<ViewEmailTemplate />}
        />


        {/* Sub Admin Routes */}
        <Route exact path="/taxi-admin/sub-admin" element={<SubAdmin />} />
        <Route exact path="/taxi-admin/user-car" element={<UserCar />} />
        {/* <Route exact path="/taxi-admin/taxi-admin" element={<Expat />} />
        <Route exact path="/taxi-admin/psychologist" element={<Psychology />} />
        <Route exact path="/taxi-admin/subscription" element={<Subscription />} />
        <Route exact path="/taxi-admin/profile" element={<Profile />} />
        <Route exact path="/taxi-admin/discount-manager" element={<Coupon />} />
        <Route exact path="/taxi-admin/banner-manager" element={<Banner />} /> */}
        {/* <Route
          exact
          path="/taxi-admin/question-manager/add-question"
          element={<AddQuestion />}
        /> */}
        {/* <Route exact path="/taxi-admin/question-manager" element={<Question />} />
        <Route exact path="/taxi-admin/language-manager" element={<Language />} />
        <Route
          exact
          path="/taxi-admin/area-of-expertise"
          element={<AreaOfExperties />}
        />
        <Route
          exact
          path="/taxi-admin/psychologist-type"
          element={<PsychologistType />}
        />
        <Route exact path="/taxi-admin/content-manager" element={<Content />} />
        <Route exact path="/taxi-admin/booking-manager" element={<Booking />} />
        <Route
          exact
          path="/taxi-admin/transaction-manager"
          element={<Transaction />}
        />
        <Route
          exact
          path="/taxi-admin/view-taxi-admin/:id"
          element={<ViewExpact />}
        />
        <Route
          exact
          path="/taxi-admin/view-psychologist/:id"
          element={<ViewPsychologist />}
        />
        <Route
          exact
          path="/taxi-admin/view-subscription/:id"
          element={<ViewSubscription />}
        />
        <Route
          exact
          path="/taxi-admin/email-manager"
          element={<EmailTemplate />}
        />
        <Route
          exact
          path="/taxi-admin/notification-manager"
          element={<Notification />}
        />
        <Route exact path="/taxi-admin/article-manager" element={<Artical />} />
        <Route exact path="/taxi-admin/article-topic" element={<ArticalTopic />} />
        <Route exact path="/taxi-admin/view-coupon/:id" element={<ViewCoupon />} />
        <Route
          exact
          path="/taxi-admin/view-content/:id"
          element={<ViewContent />}
        />
        <Route
          exact
          path="/taxi-admin/view-notification/:id"
          element={<ViewNotification />}
        />
        <Route
          exact
          path="/taxi-admin/view-email-template/:id"
          element={<ViewEmailTemplate />}
        />
        <Route
          exact
          path="/taxi-admin/question-manager/edit-question/:position"
          element={<EditQuestion />}
        />
        <Route exact path="/taxi-admin/report-manager" element={<Report />} />
        <Route exact path="/taxi-admin/review-manager" element={<Review />} />
        <Route exact path="/taxi-admin/answer-manager" element={<Answer />} />
        <Route exact path="/taxi-admin/view-answer/:id" element={<ViewAnswer />} />
        <Route exact path="/taxi-admin/payout" element={<Settlement />} />
        <Route
          exact
          path="/taxi-admin/cancellation-manager"
          element={<CancellationBooking />}
        />
        <Route
          exact
          path="/taxi-admin/access-manager"
          element={<AccessManagement />}
        />
        <Route
          exact
          path="/taxi-admin/availiblity-manager"
          element={<Availibility />}
        />
        <Route
          exact
          path="/taxi-admin/referal-manager"
          element={<Referal />}
        /> */}
      </Route>
      <Route path="*" element={<Error />} />
    </Routes>
  )
}

const Layout = () => {
  return (<> <Outlet />  </>
  )
}


export default App;
